import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";
import AuthSkeleton from "../components/SkeletonLoading/AuthSkeleton";

const AdminRoute: React.FC = () => {
  const { isAuthenticated, isLoading, isAdmin } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <AuthSkeleton />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/home/dashboard" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
